module.exports = __webpack_public_path__ + "static/media/mongoDB.327228cc.svg";